import { React, useState, useEffect } from "react";

import { useLocation, useParams } from "react-router-dom";

import HeadingBanner from "../components/HeadingBanner";
import LeftPanel from "../components/LeftPanel";
import ResultsOverview from "../components/ResultsOverview";
import OrientationPrompt from "../components/OrientationPrompt";

import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

function Results(props) {
  const location = useLocation();
  let classDetails = location.state.classDetails.classDetails;
  let classid = location.state.classDetails.classDetails.id;
  let gradeLevel = location.state.classDetails.classDetails.grade_level;
  let classAssessments = location.state.classAssessments.classAssessments;
  let assessment = location.state.assessment.assessment;
  let teachers = location.state.teachers.teachers;

  let name = "Results";

  let teacherid = location.state.classDetails.classDetails.teacherId;
  const [isPortrait, setIsPortrait] = useState(
    window.matchMedia("(orientation: portrait)").matches
  );

  useEffect(() => {
    const handleOrientationChange = () => {
      setIsPortrait(window.innerWidth < window.innerHeight);
    };

    window.addEventListener("resize", handleOrientationChange);

    return () => {
      window.removeEventListener("resize", handleOrientationChange);
    };
  }, []);

  return (
    <Container fluid className="vh-100">
      <HeadingBanner
        name={name}
        isLoggedIn={true}
        cloud={true}
        teacherid={teacherid}
      />
      <Row className="h-100">
        <LeftPanel />
        <Col sm={{ span: 10, offset: 2 }} className="blue-background">
          <ResultsOverview
            classDetails={classDetails}
            gradeLevel={gradeLevel}
            classAssessments={classAssessments}
            classid={classid}
            assessment={assessment}
            teachers={teachers}
          />
        </Col>
      </Row>
      {isPortrait && <OrientationPrompt />}
    </Container>
  );
}

export default Results;
